import styled from 'styled-components'

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1rem 0.4rem 0;

  button {
    margin-left: 1rem;
  }
`
